import React from "react";
import R14, {
  StyleSheet,
  Text,
  View,
  ScrollView,
  Form,
} from "../core";
import DropDown from "../components/DropDown";
import { commonStyles } from "../assets/css/commonStyle";
import { customCommonStyles } from "../assets/css/customCommonStyle";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import { DEFAULT_COUNTRY } from "../constant/app.data.constant";
import CommonUtility from "../utils/CommonUtility";
import { CommonString } from "../constant/appCommonText";

export default R14.connect(
  class ProfileViewScreen extends React.Component {
    constructor(props) {
      super(props);
      this.profileView = { ...this.props.userBUDetails[0], ...this.props.profile};
      this.scrollRef = React.createRef();
      this.actionType = this.props.profileActionType;
    }


    async componentDidMount() {
      try {
        if (this.actionType === "view") {
          if (!this.profileView.country || this.profileView.country === "US") {
            this.profileView.country = DEFAULT_COUNTRY.label;
          }
        }

        // Currency Format outside of edit because, by default US format should be selected
        const form = this.props.app.ui.form("profileView");
        form.elmts.currencyFormatter.setValue(this.profileView.currencyFormat);
        form.elmts.currencyFormatter.setItems(this.props.currencyFormatterList);
      } catch (error) {

      }
    }

    onCurrencyFormatChange = async(val) => {
      if(val.value && val.label) {
        const updateUserReqBody = {
          uid: this.props.profile.uid,
          currencyFormat: val
        }
        await this.props.app.dm.userRegistration.updateUserDetails(updateUserReqBody, true);
      }
    }

    renderUserIconSection() {
      return (
        <View style={[styles.userProfileDetails]}>
          <View style={[commonStyles.flex1, styles.userIconDivOuter]}>
            <View style={styles.userIconDiv}>
              <Text
                style={[commonStyles.heading4, commonStyles.fontWeight600, commonFontStyles.workSans, commonStyles.userInitial, styles.userInitial]}>
                {CommonUtility.shortName(`${this.profileView.firstName} ${this.profileView.lastName}`)}
              </Text>
            </View>
            <View style={[styles.userDetailsWrap]}>
              <View style={[styles.userDetails]}>
                {this.profileView.email && false ? (
                  <View>
                    <Text
                      style={[
                        commonFontStyles.workSans,
                        commonStyles.textInputText,
                        commonStyles.wordBreakAll
                      ]}>
                        {this.profileView.email}
                    </Text>
                  </View>
                ) : null}
                {this.profileView.mobileNumber && false ? (
                  <View>
                    <Text style={[commonFontStyles.workSans, commonStyles.textInputText, commonStyles.wordBreakAll]}>{this.profileView.mobileNumber}</Text>
                  </View>
                ) : null}
                {this.profileView.pid ? (
                  <View style={[commonStyles.marginBottom10, commonStyles.flex1, commonStyles.flexDirectionRow, commonStyles.alignItemsCenter, commonStyles.webView]}>
                    <Text style={[commonFontStyles.workSans, commonStyles.textLabelText]}>
                      {"PID: "}
                    </Text>
                    <Text style={[commonFontStyles.workSans, commonStyles.textInputText]}>
                      {this.profileView.pid}
                    </Text>
                  </View>
                ) : null}
              </View>
            </View>
          </View>
        </View>
      );
    }

    //----------- Render User Profile View.
    renderUserProfileView() {
      return (
        <View style={[customCommonStyles.webFullHeight]}>
          <ScrollView
            ref={this.scrollRef}
            style={[styles.centerScrollable, styles.profileDetailSection, customCommonStyles.customXbpProfileDetailSection, commonStyles.pageBorderRadius5, customCommonStyles.webFullHeight]}>
            <View style={[styles.customDFlex]}>
              <View style={[styles.userProfileDetailsLeft]}>{this.renderUserIconSection()}</View>
              <View style={[styles.userProfileDetailsRight, styles.maxWidth75]}>
                <View style={[commonStyles.flex1, styles.customFlecDirection, commonStyles.mView]}>
                  <View style={[commonStyles.flex1, commonStyles.flexBasis48, styles.customMarginRight8, styles.inputFields]}>
                    <View style={[styles.detailRow]}>
                      <Text
                        style={[
                          commonStyles.dBlock,
                          commonFontStyles.workSans,
                          commonStyles.marginBottom5,
                          commonStyles.textLabelText,
                        ]}>
                        {"PID"}
                      </Text>
                      <Text style={[commonStyles.dBlock, commonFontStyles.workSans, commonStyles.textInputText, styles.userDetailsVla, !this.profileView.firstName && commonStyles.disabledInput]}>
                        {this.profileView.pid || "N/A"}
                      </Text>
                    </View>
                  </View>
                  <View style={[commonStyles.flex1, commonStyles.flexBasis48, styles.customMarginLeft8, styles.inputFields, commonStyles.displayNone]}>
                  </View>
                  </View>
                <View style={[commonStyles.flex1, styles.customFlecDirection]}>
                  <View style={[commonStyles.flex1, commonStyles.flexBasis48, styles.customMarginRight8, styles.inputFields]}>
                    <View style={[styles.detailRow]}>
                      <Text
                        style={[
                          commonStyles.dBlock,
                          commonFontStyles.workSans,
                          commonStyles.marginBottom5,
                          commonStyles.textLabelText,
                        ]}>
                        {CommonString.FirstNameLabel}
                      </Text>
                      <Text style={[commonStyles.dBlock, commonFontStyles.workSans, commonStyles.textInputText, styles.userDetailsVla, !this.profileView.firstName && commonStyles.disabledInput]}>
                        {this.profileView.firstName || "N/A"}
                      </Text>
                    </View>
                  </View>
                  <View style={[commonStyles.flex1, commonStyles.flexBasis48, styles.customMarginLeft8, styles.inputFields]}>
                    <View style={[styles.detailRow]}>
                      <Text
                        style={[
                          commonStyles.dBlock,
                          commonFontStyles.workSans,
                          commonStyles.marginBottom5,
                          commonStyles.textLabelText,
                        ]}>
                        {CommonString.LastNameLabel}
                      </Text>
                      <Text style={[commonStyles.dBlock, commonFontStyles.workSans, commonStyles.textInputText, styles.userDetailsVla, !this.profileView.lastName && commonStyles.disabledInput]}>
                        {this.profileView.lastName || "N/A"}
                      </Text>
                    </View>
                  </View>
                  </View>
                  <View style={[commonStyles.flex1, styles.customFlecDirection]}>
                  <View style={[commonStyles.flex1, commonStyles.flexBasis48, styles.customMarginRight8, styles.inputFields]}>
                    <View style={[styles.detailRow]}>
                      <Text
                        style={[
                          commonStyles.dBlock,
                          commonFontStyles.workSans,
                          commonStyles.marginBottom5,
                          commonStyles.textLabelText,
                        ]}>
                        {CommonString.EmailLabel}
                      </Text>
                      <Text style={[commonStyles.dBlock, commonFontStyles.workSans, commonStyles.textInputText, styles.userDetailsVla, !this.profileView.email && commonStyles.disabledInput]}>
                        {this.profileView.email || "N/A"}
                      </Text>
                    </View>
                  </View>
                  <View style={[commonStyles.flex1, commonStyles.flexBasis48, styles.customMarginLeft8, styles.inputFields]}>
                    <View style={[styles.detailRow]}>
                      <Text
                        style={[
                          commonStyles.dBlock,
                          commonFontStyles.workSans,
                          commonStyles.marginBottom5,
                          commonStyles.textLabelText,
                        ]}>
                        {CommonString.MobilerNumberLabel}
                      </Text>
                      <Text style={[commonStyles.dBlock, commonFontStyles.workSans, commonStyles.textInputText, styles.userDetailsVla, !this.profileView.mobileNumber && commonStyles.disabledInput]}>
                        {this.profileView.mobileNumber || "N/A"}
                      </Text>
                    </View>
                  </View>
                  </View>
                <View style={[commonStyles.flex1, styles.customFlecDirection]}>
                  <View style={[commonStyles.flex1, commonStyles.flexBasis48, styles.customMarginRight8, styles.inputFields]}>
                    <View style={[styles.detailRow]}>
                      <Text
                        style={[
                          commonStyles.dBlock,
                          commonFontStyles.workSans,
                          commonStyles.marginBottom5,
                          commonStyles.textLabelText,
                        ]}>
                        {CommonString.Address1Label}
                      </Text>
                      <Text style={[commonStyles.dBlock, commonFontStyles.workSans, commonStyles.textInputText, styles.userDetailsVla, !this.profileView.addressLine1 && commonStyles.disabledInput]}>
                        {this.profileView.addressLine1 || "N/A"}
                      </Text>
                    </View>
                  </View>
                  <View style={[commonStyles.flex1, commonStyles.flexBasis48, styles.customMarginLeft8, styles.inputFields]}>
                    <View style={[styles.detailRow]}>
                      <Text
                        style={[
                          commonStyles.dBlock,
                          commonFontStyles.workSans,
                          commonStyles.marginBottom5,
                          commonStyles.textLabelText,
                        ]}>
                        {CommonString.Address2Label}
                      </Text>
                      <Text style={[commonStyles.dBlock, commonFontStyles.workSans, commonStyles.textInputText, styles.userDetailsVla, !this.profileView.addressLine2 && commonStyles.disabledInput]}>
                        {this.profileView.addressLine2 || "N/A"}
                      </Text>
                    </View>
                  </View>
                  </View>
                <View style={[commonStyles.flex1, styles.customFlecDirection]}>
                  <View style={[commonStyles.flexBasis50, styles.inputFields, styles.customMarginRight8]}>
                    <View style={[styles.detailRow]}>
                      <Text
                        style={[
                          commonStyles.dBlock,
                          commonFontStyles.workSans,
                          commonStyles.marginBottom5,
                          commonStyles.textLabelText,
                        ]}>
                        {CommonString.CountryLabel}
                      </Text>
                      <Text style={[commonStyles.dBlock, commonFontStyles.workSans, commonStyles.textInputText, styles.userDetailsVla, !this.profileView.country && commonStyles.disabledInput]}>
                        {this.profileView.country || "N/A"}
                      </Text>
                    </View>
                  </View>
                  <View style={[commonStyles.flexBasis50, styles.customMarginLeft8, styles.inputFields]}>
                    <View style={[styles.detailRow]}>
                      <Text
                        style={[
                          commonStyles.dBlock,
                          commonFontStyles.workSans,
                          commonStyles.marginBottom5,
                          commonStyles.textLabelText,
                        ]}>
                        {CommonString.StatesLabel}
                      </Text>
                      <Text style={[commonStyles.dBlock, commonFontStyles.workSans, commonStyles.textInputText, styles.userDetailsVla, !this.profileView.state && commonStyles.disabledInput]}>
                        {this.profileView.state ? this.profileView.state : "N/A"}
                      </Text>
                    </View>
                  </View>
                </View>
                <View style={[commonStyles.flex1, styles.customFlecDirection]}>
                  <View style={[commonStyles.flex1, commonStyles.flexBasis50, styles.customMarginRight8, styles.inputFields]}>
                    <View style={[styles.detailRow]}>
                      <Text
                        style={[
                          commonStyles.dBlock,
                          commonFontStyles.workSans,
                          commonStyles.marginBottom5,
                          commonStyles.textLabelText,
                        ]}>
                        {CommonString.CityLabel}
                      </Text>
                      <Text style={[commonStyles.dBlock, commonFontStyles.workSans, commonStyles.textInputText, styles.userDetailsVla, !this.profileView.town && commonStyles.disabledInput]}>
                        {this.profileView.town || "N/A"}
                      </Text>
                    </View>
                  </View>
                  <View style={[commonStyles.flexBasis50, styles.customMarginLeft8, styles.inputFields]}>
                    <View style={[styles.detailRow]}>
                      <Text
                        style={[
                          commonStyles.dBlock,
                          commonFontStyles.workSans,
                          commonStyles.marginBottom5,
                          commonStyles.textLabelText,
                        ]}>
                        {CommonString.ZipCodeLabel}
                      </Text>
                      <Text style={[commonStyles.dBlock, commonFontStyles.workSans, commonStyles.textInputText, styles.userDetailsVla, !this.profileView.postCode && commonStyles.disabledInput]}>
                        {this.profileView.postCode || "N/A"}
                      </Text>
                    </View>
                  </View>
                </View>
                <View style={[commonStyles.flex1, styles.customFlecDirection, commonStyles.marginTop10]}>
                  <Form
                    name="profileView"
                    style={[commonStyles.flex1, styles.profileViewForm]}
                    onSubmit={() => null}
                    validateBeforeSubmit={false}>
                    <View>
                      <DropDown
                        name="currencyFormatter"
                        label={CommonString.CurrencyFormatterLabel}
                        style={[commonStyles.flex0, commonFontStyles.workSans, commonStyles.heading6, commonFontStyles.workSans, customCommonStyles.inputHeight]}
                        labelTextStyle={[commonStyles.labelText, commonFontStyles.workSans, commonStyles.heading6]}
                        labelStyle={[commonStyles.formLabelStyle, customCommonStyles.inputLableStyle, customCommonStyles.selectMenuInputLabelStyle]}
                        items={this.props.currencyFormatterList}
                        onValueChange={this.onCurrencyFormatChange}
                        searchable={false}
                        disabled={false}
                        readOnly={false}
                      />
                    </View>
                  </Form>
                </View>
              </View>
            </View>
          </ScrollView>
        </View>
      );
    }

    render() {
      if (this.profileView.mobileNumber) {
        let splitPhoneNumber = this.profileView.mobileNumber.split(" ");
        if (splitPhoneNumber[1]) {
          let match = splitPhoneNumber[1].match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
          if (match) {
            let formattedString = "";
            match[1] = splitPhoneNumber[0] + " ";
            formattedString = [match[1], "(", match[2], ") ", match[3], "-", match[4]].join("");
            this.profileView.mobileNumber = "";
            this.profileView.mobileNumber = formattedString;
          }
        } else {
          let match = splitPhoneNumber[0].match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
          if (match) {
            let formattedString = "";
            match[1] = "+1 ";
            formattedString = [match[1], "(", match[2], ") ", match[3], "-", match[4]].join("");
            this.profileView.mobileNumber = "";
            this.profileView.mobileNumber = formattedString;
          }
        }
      }
      return (
        <>
            <View style={[styles.container, customCommonStyles.webFullHeight]}>
              {this.actionType === "view" ? this.renderUserProfileView() : null}
            </View>
        </>
      );
    }
  }
);

const styles = StyleSheet.create({
  profileDetailSection: {
    backgroundColor: "#fff",
    padding: 16,
    marginTop: 0,
    marginRight: 16,
    marginBottom: 0,
    marginLeft: 16,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#d6d6d6",
    flexGrow: 0,
    screen: ({ width }) => {
      if (width <= 640)
        return {
          flex: 1,
          marginRight: 0,
          marginLeft: 0,
          border: 0,
          minHeight: "100%",
          paddingBottom: 20
        };
      if(width >= 640 && width <= 992) {
        return {
          marginTop: 16,
        };
      }
    },
  },
  centerScrollable: {
    flex: 1
  },
  inputFields: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    screen: ({ width }) => {
      if (width >= 991 && width <= 1083) {
        return {
          flexBasis: "48%",
        };
      }
      if (width <= 991) {
        return {
          flexBasis: "100%",
          width: "100%",
          marginRight: 0,
          marginLeft: 0,
        };
      }
    },
  },
  userDetailsVla: {
    minHeight: 18,
    wordBreak: "break-all"
  },
  userIconDiv: {
    width: 60,
    maxWidth: 60,
    minWidth: 60,
    height: 60,
    borderTopLeftRadius: 60,
    borderTopRightRadius: 60,
    borderBottomLeftRadius: 60,
    borderBottomRightRadius: 60,
    backgroundColor: "#e7e7e7",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    marginBottom: 10,
    screen: ({ width }) => {
      if (width <= 992) {
        return {
          marginRight: 16,
          marginBottom: 0,
        };
      }
    },
  },
  detailRow: {
    borderBottomWidth: 1,
    borderStyle: "solid",
    borderColor: "rgb(218, 218, 218)",
    paddingBottom: 5,
    marginBottom: 15,
    flex: 1,
    screen: ({ width }) => {
      if (width <= 991) {
        return {
          marginBottom: 10,
        };
      }
      if (width >= 992) {
        return {
          height: 47,
        };
      }
    },
  },
  customMarginRight8: {
    marginRight: 8,
    screen: ({ width }) => {
      if (width <= 991) {
        return {
          marginRight: 0,
        };
      }
    },
  },
  customMarginLeft8: {
    marginLeft: 8,
    screen: ({ width }) => {
      if (width <= 991) {
        return {
          marginLeft: 0,
        };
      }
    },
  },
  userProfileDetails: {
    marginRight: 16,
    screen: ({ width }) => {
      if (width <= 991) {
        return {
          marginBottom: 20,
          marginRight: 0,
        };
      }
    },
  },
  userProfileDetailsLeft: {
    width: "100%"
  },
  customDFlex: {
    flex: 1,
    flexDirection: "column",
    minWidth: "100%",
    alignItems: "flex-start",
    screen: ({ width }) => {
      if (width <= 991) {
        return {
          minHeight: "100%",
        };
      }
    },
  },
  userDetails: {
    textAlign: "left",
    minWidth: 170,
    screen: ({ width }) => {
      if (width <= 991) {
        return {
          textAlign: "left",
        };
      }
    },
  },
  userDetailsWrap: {
    screen: ({ width }) => {
      if (width <= 991) {
        return {
          flexBasis: "100%",
          maxWidth: "100%",
        };
      } else {
        return {
          justifyContent: "center",
          marginLeft: 16,
          flex: 1,
        }
      }
    },
  },
  customFlecDirection: {
    flexDirection: "row",
    screen: ({ width }) => {
      if (width <= 991) {
        return {
          flexDirection: "column",
        };
      }
    },
  },
  userIconDivOuter: {
    flexDirection: "row",
    alignItems: "left",
    minWidth: "66%",
    screen: ({ width }) => {
      if (width <= 991) {
        return {
          minWidth: "100%",
        };
      }
    },
  },
  userProfileDetailsRight: {
    flexGrow: 1,
    screen: ({ width }) => {
      if (width >= 992) {
        return {
          flexGrow: 1,
        };
      }
      if (width <= 992) {
        return {
          flexGrow: 0,
          width: "100%",
        };
      }
    }
  },
  maxWidth75: {
    screen: ({ width }) => {
      if (width >= 992) {
        return {
          minWidth: "66%",
          maxWidth: "66%"
        };
      }
    },
  },
  profileViewForm: {
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    minHeight: '100%',
    maxWidth: "49%",
    minWidth: "49%",
    screen: ({ width }) => {
      if (width <= 991) {
        return {
          maxWidth: "100%",
        };
      }
    },
  },
});
